let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5uoHm"), load("fRSjL")]).then(() => parcelRequire('lwnQ4'));